import BM_animation from './BM_animation';
import bodymovin from 'bodymovin';

$(document).ready(function(){

    var $elements = $('.Home-container, .home .Cover, .Home-cta'),
        scrollTop,
        jLinks = $('.dot-container .dot'),
        wHeight
    ;

    $('.Home-container').each(function(){
      let $img = $('.Home-img',$(this));
      let data = $img.attr('id');
      let $loader = $('.loader',$(this))
      ;

      /**
       * @see function BM_animation
       **/
      var animation = BM_animation(data)
      ;
      animation.setSpeed(0.9);

          animation.addEventListener('DOMLoaded', function(){
             $loader.css('display','none');
          });
      // animation.addEventListener('data_ready', function(){
      //     animation.play();
      // });
   })
    $(window).scroll(function() {
        scrollTop = $(window).scrollTop();
        wHeight = $(window).height();

        // Pour chaque slice, on vérifie si elle est au niveau pour apparaitre
        $elements.each(function(){
            var offset = $(this).offset().top,
                minTop = wHeight/5
            ;

            // Si on est au niveau du nouvelle slice
            if(scrollTop + wHeight - minTop > offset){



                if($(this).is('.Cover, .Home-container')){
                    var index = ($(this).is('.Cover')) ? -1 : $(this).index();
                    jLinks.not(':eq(' + (index+1) + ')').removeClass('active');
                    jLinks.eq(index+1).addClass('active');
                }
                // Si elle n'est pas encore affichée
                if(!$(this).hasClass('shown')){
                    $(this).addClass('shown');

                    if($(this).is('.home .Cover')){
                        showCover($(this));
                    }

                     if($(this).is('.Home-container')){
                         showIllustration($(this));
                     }

                     if($(this).is('.Home-cta')){
                         showCta($(this));
                     }
                }
            }

        });
    }).trigger('scroll');

    function showIllustration($el){
        const $img = $('.Home-img',$el),
            $txt = $('.Home-txt',$el),
            $animation = $img.attr('id')
        ;


        var tl = new TimelineLite({
           onStart:()=>{
             bodymovin.play($animation)
          }
        });

        tl.fromTo($img,1,{autoAlpha:0,y:'+=100'},{autoAlpha:1,y:0,ease:Power4.easeOut});
        tl.fromTo($txt,1,{autoAlpha:0,y:'+=100'},{autoAlpha:1,y:0,ease:Power4.easeOut},'-=.5');


    }

    function showCover($el){
        var $img = $('.Cover-logo',$el),
            $txt = $('.Cover-txt',$el)
        ;

        var tl = new TimelineLite();

        tl.fromTo($img,.8,{autoAlpha:0,y:'+=100'},{autoAlpha:1,y:0,ease:Power4.easeOut},'-=.2');
        tl.fromTo($txt,.8,{autoAlpha:0,y:'+=80'},{autoAlpha:1,y:0,ease:Power4.easeOut},'+=.2');
        tl.fromTo($('.Cover-btn'),0.8,{autoAlpha:0,y:'+=100'},{autoAlpha:1,y:0,ease:Power4.easeOut},'-=.2');


    }

    function showCta($el){
      var tl = new TimelineLite();
      tl.fromTo($el,.8,{autoAlpha:0,y:'+=100'},{autoAlpha:1,y:0,ease:Power4.easeOut});
    }

    $('.dot').click(function(){
        $('html, body').stop().animate({
            scrollTop: $( $(this).attr('href') ).offset().top -100
        }, 800);
        return false;
    })
});
